import type {EstablishedAhpSession} from './contracts'

/**
 * Brings an established session to `mode` with a `session/configChanged` only when
 * the host does not already report it in `SessionState.config.values.mode`. A
 * session created with `config.mode` is already in that mode, so this sends
 * nothing; an attached session or a host that does not publish `mode` gets a
 * single write.
 */
export async function ensureSessionMode(
  session: Pick<EstablishedAhpSession, 'view' | 'commands'>,
  mode: string | undefined,
): Promise<void> {
  if (!mode || session.view.getSnapshot().sessionState?.config?.values?.mode === mode) return
  await session.commands.setMode(mode)
}
